import { Box, Button, Stack } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { postMaterialCell } from "../../../services/CellService";
import { CellPostPayload } from "../../../types/CellTypes";
import { RHFRadioGroup } from "../../hook-form/RHFRadioGroup";
import { RHFTextField } from "../../hook-form/RHFTextField";

type Props = {
  operatorId: number;
  onSuccess?: () => void;
};

export function CellForm({ operatorId, onSuccess }: Props) {
  const methods = useForm<{ cellBatch: string; cellType: string }>({
    defaultValues: {
      cellBatch: "",
      cellType: "",
    },
  });

  const { control, handleSubmit, reset } = methods;

  const onSubmit = async (data: { cellBatch: string; cellType: string }) => {
    const payload: CellPostPayload = {
      operatorid: String(operatorId),
      stationid: 58,
      dateInProduction: new Date().toISOString(),
      cellBatch: data.cellBatch,
      cellType: data.cellType,
    };

    try {
      await postMaterialCell(payload);
      reset();
      onSuccess?.();
    } catch (err: any) {
      if (err.code === "ERR_CANCELED" || err.name === "CanceledError") {
        console.debug("CellForm request canceled");
        return;
      }
      console.error("Fehler beim Absenden:", err);
    }
  };

  return (
    <FormProvider {...methods}>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <RHFTextField
            name="cellBatch"
            label="Batch Nr."
            control={control}
            required
          />
          <RHFRadioGroup
            name="cellType"
            label="Zellentyp"
            control={control}
            options={[
              { label: "22.4%-1 D", value: "22.4%-1 D" },
              { label: "22.4%-2 D", value: "22.4%-2 D" },
            ]}
          />
          <Button type="submit" variant="contained" color="primary">
            Speichern
          </Button>
        </Stack>
      </Box>
    </FormProvider>
  );
}
